// конвертация размера файла из байтов в строку

export function convertBytesToString(bytes: number) {
  if (bytes === 0) return '0 Мб'

  const sizes = ['Байт', 'Кб', 'Мб', 'Гб']

  const i = Math.floor(Math.log(bytes) / Math.log(1024))

  return `${parseFloat((bytes / 1024 ** i).toFixed(2))} ${sizes[i]}`
}
